/* eslint-disable no-case-declarations */
import * as Types from '../ActionTypes'
import {metasInitialState} from './metaInitalState'


export const metaReducer = function(state = metasInitialState, action) {
    switch (action.type) {
    case Types.GET_METAS_REQUEST:
        return {
            ...state,
            isFetchingMetas: true
        }

    case Types.GET_METAS_SUCCESS:
        return {
            ...state,
            isFetchingMetas: false,
            metas: action.payload
        }

    case Types.CREATE_META_REQUEST:
        return {
            ...state,
            isUploadingMeta: true
        }

    case Types.CREATE_META_SUCCESS:
        return {
            ...state,
            isUploadingMeta: false,
            metas: [
                ...state.metas,
                action.payload
            ]
        }

    case Types.CREATE_META_FAILURE:
        return {
            ...state,
            isUploadingMeta: false,
            error: action.payload
        }

    case Types.DELETE_META_REQUEST:
        return {
            ...state,
            isDeletingMeta: true
        }

    case Types.DELETE_META_SUCCESS:
        return {
            ...state,
            isDeletingMeta: false,
            metas: state.metas.filter(meta => meta.id !== action.payload)
        }

    case Types.DELETE_META_FAILURE:
        return {
            ...state,
            isDeletingMeta: false,
            error: action.payload
        }

    case Types.EDIT_META_REQUEST:
        return {
            ...state,
            isUpdatingMeta: true
        }

    case Types.EDIT_META_SUCCESS:
        const index = state.metas.findIndex(meta => meta.id === action.payload.id)
        state.metas[index] = action.payload
        return {
            ...state,
            isUpdatingMeta: false
        }

    case Types.EDIT_META_FAILURE:
        return {
            ...state,
            isUpdatingMeta: false,
            error: action.payload
        }

    default: return state
    }
}

export default metaReducer
